export default __webpack_public_path__ + "static/media/grafema_capitolio_09.eac27633.jpg";